module.exports = __webpack_public_path__ + "static/media/CNN.6b5d309a.png";